const template = document.createElement("template");

const showMore = "mehr anzeigen";
const showLess = "weniger anzeigen";

template.innerHTML = `
  <style></style>
  <slot></slot>
`;

export class Toc extends HTMLElement {
  get tocTarget(): string {
    return this.getAttribute("toc-target") ?? "";
  }

  get maxItems(): number {
    const value = this.getAttribute("max-items");
    return value ? parseInt(value, 10) : 0;
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot!.appendChild(template.content.cloneNode(true));
  }

  connectedCallback() {
    const button = this.querySelector("button");
    button?.addEventListener("click", this.#handleClick);
    // no explicit initial hiding, happens via links.edge
    // (because we define the values there & decide there if <ws-toc> is needed at all)
  }

  #handleClick = (event: MouseEvent) => {
    this.toggleTocItems();
    event.preventDefault();
    event.stopPropagation();
  };

  toggleTocItems(): void {
    const targetId = this.tocTarget;
    const maxItems = this.maxItems;

    if (!targetId) return;

    const tocElement = document.getElementById(targetId);
    if (!tocElement || tocElement.tagName !== "UL") return;

    const listItems = tocElement.querySelectorAll("li");

    let hasHiddenItems = false;

    listItems.forEach((li, index) => {
      if (index >= maxItems) {
        li.hidden = !li.hidden;
        if (li.hidden) hasHiddenItems = true;
      }
    });

    const button = this.querySelector("button");
    if (!button) return;

    button.textContent = hasHiddenItems ? showMore : showLess;
    button.ariaExpanded = hasHiddenItems ? "false" : "true";
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.#handleClick);
  }
}

"customElements" in window &&
  customElements.get("ws-toc") === undefined &&
  customElements.define("ws-toc", Toc);

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface HTMLElementTagNameMap {
    "ws-toc": Toc;
  }
}
